export const accountRoutes = {
  notificationSettings: "settings/notifications",
} as const;
